import { Node_Type } from "./../../ricos-types/index.js";
import VerticalEmbed from "./verticalEmbed.js";
const nodeViewRenderers = {
  [Node_Type.APP_EMBED]: VerticalEmbed
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
